export const STAFF_TAB_IDS = [
  'subscriptions',
  'whatsapp',
  'receipts',
  'generate_receipt',
  'analytics',
  'member_analytics',
  'quiz_leads',
  'quiz_creator',
  's3_upload',
  'coupon_usage',
  'magazines',
  'manual_subscriptions'
];

export const TAB_LABELS = {
  subscriptions: 'Subscriptions',
  whatsapp: 'WhatsApp',
  receipts: 'Receipts',
  generate_receipt: 'Generate Receipt',
  analytics: 'Analytics',
  member_analytics: 'Member Analytics',
  quiz_leads: 'Quiz Leads',
  quiz_creator: 'Quiz Creator',
  s3_upload: 'S3 Upload',
  coupon_usage: 'Coupon Usage',
  magazines: 'Magazines',
  manual_subscriptions: 'Manual Subs',
  manage_admins: 'Admins'
};
